import { useEffect } from 'react';

/**
 * Hook para definir título da página e favicon condicionalmente
 * @param {string} title - Título da aba
 * @param {string} faviconType - 'pp' para Pavan e Parazzi, 'ap' para AP Finanças
 */
export const usePageMeta = (title, faviconType = 'pp') => {
  useEffect(() => {
    // Definir título
    document.title = title;
    
    // Definir favicon
    const faviconPath = faviconType === 'ap' ? '/favicon-ap.png' : '/favicon-pp.png';
    
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    // Adicionar timestamp para forçar atualização do cache
    link.href = faviconPath + '?v=' + Date.now();
    
    return () => {
      // Cleanup não necessário para título/favicon
    };
  }, [title, faviconType]);
};

export default usePageMeta;
